import { createFileRoute } from '@tanstack/react-router'
import ContactsPageClient from '#/components/contacts/ContactsPageClient'

export const Route = createFileRoute('/_authenticated/$slug/settings/contacts')({
  component: ContactsPageClient,
})
